// extracted by mini-css-extract-plugin
export default {"FullViewHeader":"FullViewHeader_FullViewHeader__7YFwb","New":"FullViewHeader_New__PzKYd","Change":"FullViewHeader_Change__JqS2J","Text":"FullViewHeader_Text__K4G-1"};